<template>
  <div class="winners-2021-winner">
    <div class="winners-2021-winner__main">
      <img
        src="@/assets/img/winners/2021/beams.png"
        alt=""
        class="winners-2021-winner__beams"
      />
      <img
        src="@/assets/img/prizes/2021/game-place.png"
        alt="Игровое место"
        class="winners-2021-winner__prize"
      />
      <img
        src="@/assets/img/prizes/2021/game-place-runes.png"
        alt=""
        class="winners-2021-winner__runes"
      />
      <Winners2021WinnerUser class="winners-2021-winner__user" />
    </div>
    <div class="winners-2021-winner__text">
      <Winners2021PlaceChip>
        1 место
      </Winners2021PlaceChip>
      <p class="winners-2021-winner__text_big">
        Апгрейд игрового места
      </p>
      <a
        href="https://bit.ly/hyperPC_rr_g"
        target="_blank"
        class="winners-2021-winner__text-subtitle"
      >
        HYPERPC GAMING X3 на базе Intel®️ Core™️ i7 и NVIDIA GeForce RTX 3080
      </a>
      <div class="winners-2021-winner__text_small">
        <a href="https://clc.am/H500M" target="_blank" rel="noopener"
          >Корпус Cooler Master</a
        >&nbsp;
        <a href="https://clc.am/ML240R" target="_blank" rel="noopener"
          >кулер Cooler Master</a
        >&nbsp;
        <a href="https://clc.am/vGold750" target="_blank" rel="noopener"
          >блок питания Cooler Master</a
        >&nbsp;
        <a href="https://clc.am/chair1" target="_blank" rel="noopener"
          >игровое кресло Cooler Master</a
        >&nbsp;
        <a
          href="https://hyperx.gg/RBRR_Revolver71"
          target="_blank"
          rel="noopener"
          >игровые наушники HyperX</a
        >&nbsp;
        <a href="https://hyperx.gg/RBRR_QuadCast" target="_blank" rel="noopener"
          >микрофон HyperX</a
        >&nbsp;
        <a href="https://bit.ly/AOC_rr_1" target="_blank" rel="noopener"
          >игровой монитор от AOC</a
        >&nbsp;
        <a href="https://hyperx.gg/RBRR_Haste" target="_blank" rel="noopener"
          >игровая мышь HyperX</a
        >&nbsp;
        <a href="http://bit.ly/hyperX_rr" target="_blank" rel="noopener"
          >коврик для мыши HyperX</a
        >&nbsp;
        <a
          href="https://hyperx.gg/RBRR_AlloyElite2"
          target="_blank"
          rel="noopener"
          >клавиатура HyperX</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import Winners2021PlaceChip from "./Winners2021PlaceChip";
import Winners2021WinnerUser from "./Winners2021WinnerUser";

export default {
  name: "Winners2021Winner",
  components: {
    Winners2021PlaceChip,
    Winners2021WinnerUser
  }
};
</script>

<style lang="scss">
.winners-2021-winner {
  border-radius: 6px;
  background: linear-gradient(180deg, rgba(#1e2135, 0.4), rgba(#304d96, 0.4));
  padding: 20px 50px 40px;
  font-family: "Montserrat";
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;

  .winners-2021-place-chip {
    height: 44px;
    width: 160px;
    font-size: 20px;
    margin-bottom: 40px;
  }

  &__main {
    position: relative;
    width: 550px;
    max-width: 100%;
    flex-shrink: 0;
    margin-right: 35px;
    height: 525px;

    z-index: 1;
  }

  &__beams {
    position: absolute;
    top: -25px;
    left: -40px;
    width: 600px;
    height: 600px;
  }

  &__prize {
    position: absolute;
    top: 0;
    left: 55px;

    width: 430px;
    height: 355px;
  }

  &__runes {
    position: absolute;
    top: 0;
    left: 50px;

    width: 445px;
    height: 400px;
  }

  &__user {
    position: absolute;
    z-index: 3;
    top: 150px;
    left: 50%;
    transform: translateX(-50%);
  }

  &__text {
    line-height: 1.15;
    padding-top: 75px;
  }

  &__text_big {
    font-weight: 900;
    font-size: 41px;
    margin-bottom: 15px;
    text-transform: uppercase;
    max-width: 450px;
    margin-bottom: 40px;
  }

  &__text-subtitle {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 40px;
    line-height: 1.3;
    display: block;
    color: #fff;
    max-width: 220px;
  }

  &__text_small {
    font-size: 13px;
    font-weight: 300;
    line-height: 1.35;
    letter-spacing: 0.01em;

    a {
      color: #fff;
      font-weight: inherit;
      &:hover {
        text-decoration: underline;
      }

      &:not(:last-of-type)::after {
        content: ", ";
        display: inline;
      }
    }
  }

  @include breakpoint("md-and-down") {
    flex-wrap: wrap;
    justify-content: center;
    &__main {
      margin-right: 0;
    }
    &__text_big {
      max-width: 100%;
    }
    &__text-subtitle {
      max-width: 100%;
    }
    &__text {
      text-align: center;
      padding-top: 30px;
    }
    .winners-2021-place-chip {
      margin-left: auto;
      margin-right: auto;
    }
  }

  @include breakpoint("sm-and-down") {
    padding: 30px 15px;
    &__main {
      height: 500px;
    }

    &__text_big {
      font-size: 30px;
      margin-bottom: 25px;
    }
    &__text-subtitle {
      font-size: 14px;
      margin-bottom: 25px;
    }
    &__text_small {
      font-size: 12px;
    }
    &__beams {
      top: 50%;
      left: 48%;
      width: 100%;
      height: auto;
      transform: translate(-50%, -50%);
    }

    &__prize {
      top: 40%;
      left: 50%;
      width: 85%;
      height: auto;
      transform: translate(-50%, -50%);
    }

    &__runes {
      top: 45%;
      left: 50%;
      width: 85%;
      height: auto;
      transform: translate(-50%, -50%);
    }
  }

  @include breakpoint("xs-only") {
    padding: 15px 12px 25px;
    &__text {
      padding-top: 20px;
    }
    &__text_big {
      font-size: 21px;
    }
    &__text_small {
      font-size: 11px;
      text-align: left;
    }
    &__text-subtitle {
      font-size: 13px;
      margin-bottom: 25px;
    }
  }

  @media (max-width: 500px) {
    &__main {
      height: 420px;
    }
    &__user {
      top: 100px;
    }
  }

  @media (max-width: 400px) {
    &__prize {
      top: 35%;
      left: 50%;
      width: 100%;
      height: auto;
      transform: translate(-50%, -50%);
    }

    &__runes {
      top: 40%;
      left: 50%;
      width: 100%;
      height: auto;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
